// Helpers puros de foto por cor (ADR-012 F2, RN-V07/V08/V09).
// Extraidos de components/PhotosTab.tsx pro lint nao acusar
// react-refresh/only-export-components (arquivo de componente so pode
// exportar componente; funcao utilitaria exportada quebra o fast refresh).
import type { MediaItem, ProductDetail } from "./types";

/** Normaliza pra comparar nome de subpasta com cor: sem acento, maiuscula, trim.
 *  Igual em espirito ao normalizeToken do worker (RN-V07), mas so pra UI —
 *  a fonte de verdade do casamento e sempre o backend (colors_source='drive'). */
export function normalizeForCompare(s: string): string {
  return s
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[\s_-]+/g, " ")
    .trim()
    .toUpperCase();
}

export function mediaColors(m: MediaItem): string[] {
  return m.colors ?? [];
}

// (isPrincipal saiu em 2026-10-13: nao existe mais "foto principal" exclusiva.
// Toda foto do canal vai na galeria do produto; cor so acrescenta.)

/** Foto veio de subpasta e o Drive nao achou cor correspondente: pendencia visivel. */
export function isPendingUnmatched(m: MediaItem): boolean {
  return (m.colors_source ?? "none") === "drive" && mediaColors(m).length === 0 && !!m.drive_subfolder;
}

/** RN-V08: operadora corrigiu a mao e a cor diverge da pasta de origem. */
export function manualDivergesFromFolder(m: MediaItem): string | null {
  if ((m.colors_source ?? "none") !== "manual" || !m.drive_subfolder) return null;
  const folder = normalizeForCompare(m.drive_subfolder);
  const matches = mediaColors(m).some((c) => normalizeForCompare(c) === folder);
  return matches ? null : m.drive_subfolder;
}

/** Contagem de pendencias pra badge na aba (ProductPage.tsx TabsTrigger). */
export function countPhotosPending(product: ProductDetail, slug: string): number {
  return product.media.filter((m) => m.channels.includes(slug) && isPendingUnmatched(m)).length;
}
